<div
  class="h-screen flex flex-col"
  [ngClass]="{ 'bg-primary-50': !showRightSection }"
>
  <div class="flex-1 flex h-full overflow-hidden">
    <!-- Left Side -->
    <div
      class="flex flex-col"
      [ngClass]="
        !isEditMode
          ? !showRightSection
            ? 'w-full'
            : 'w-full lg:w-2/5'
          : 'w-full lg:w-2/3 mx-auto'
      "
    >
      <!-- <div class="flex items-center space-x-2 text-black p-6">
         <button mat-icon-button [routerLink]="['/']">
          <mat-icon class="text-primary mt-2"> chevron_left </mat-icon>
        </button> 
        <img [src]="logoImg" class="w-12" alt="AsylumTix" />
      </div> -->
      <div
        class="flex items-center justify-between px-10 lg:px-20 lg:py-14 py-10"
      >
        <h4 class="text-4xl font-jura text-primary font-bold">AsylumTix</h4>

        <!-- Logout Button -->
        <button
          *ngIf="user$ | async"
          (click)="onLogout()"
          class="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-gray-500 hover:text-primary-600 transition-colors duration-200"
          type="button"
        >
          <span>Logout</span>
          <mat-icon class="text-lg">logout</mat-icon>
        </button>
      </div>

      <div class="px-10 lg:px-20 overflow-y-auto">
        <router-outlet></router-outlet>
      </div>
    </div>

    <!-- Right Side -->
    <div
      *ngIf="!isEditMode && showRightSection"
      class="hidden lg:flex flex-col text-white text-center w-3/5 bg-bg-auth bg-cover"
    >
      <div class="flex items-center justify-end space-x-2 p-6">
        <a
          target="_blank"
          href="mailto:support@asylumtix.com"
          class="text-sm font-medium text-white"
          >Need help?</a
        >
        <mat-icon class="text-white">help</mat-icon>
      </div>

      <!-- Body -->
      <div class="flex-1 flex flex-col space-y-5 items-center justify-center">
        <!-- Title -->
        <h4 class="font-medion text-4xl">
          From check-in to sold-out, <br />
          we've got your venue covered.
        </h4>
        <!-- Subtitle -->
        <p class="text-md text-[#CAE6FF] w-1/2">
          Manage every step of your event with our all-in-one ticketing
          solution. We provide the tools your venue staff need to stay in
          control and keep the focus on delivering a standout experience.
        </p>
      </div>
      <!-- Footer -->
      <div class="px-0 py-8 border-t border-t-[#FFFFFF0A]">
        <ul class="inline-flex space-x-3 text-sm">
          <li>
            <a
              href="/policy-tos"
              class="hover:underline text-[#CAE6FF] cursor-pointer"
              >Terms and Conditions</a
            >
          </li>
          <li class="pt-1.5">
            <svg
              width="4"
              height="4"
              viewBox="0 0 4 4"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="5" cy="5" r="3" fill="#DDE3EA80" />
            </svg>
          </li>
          <li>
            <a
              href="/policy-privacy"
              class="hover:underline text-[#CAE6FF] cursor-pointer"
              >Privacy Policy</a
            >
          </li>
          <li class="pt-1.5">
            <svg
              width="4"
              height="4"
              viewBox="0 0 4 4"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="5" cy="5" r="3" fill="#DDE3EA80" />
            </svg>
          </li>
          <li>
            <a
              href="/policy-refund"
              class="hover:underline text-[#CAE6FF] cursor-pointer"
              >Refund Policy</a
            >
          </li>
          <li class="pt-1.5">
            <svg
              width="4"
              height="4"
              viewBox="0 0 4 4"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="5" cy="5" r="3" fill="#DDE3EA80" />
            </svg>
          </li>
          <li>
            <a
              target="_blank"
              href="mailto:support@asylumtix.com"
              class="hover:underline text-[#CAE6FF] cursor-pointer"
            >
              Sell Tickets Wth Us</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
